import styles from '../../styles/modules/faq/Faq.module.scss';

const FAQ_LIST = [
	{
		id: 1,
		title: 'Никаких игр на реальные деньги',
		text: 'Во всех играх используются виртуальные кредиты, которые не имеют денежной стоимости.',
	},
	{
		id: 2,
		title: 'Без денежных призов',
		text: 'Выигрыши и бонусы не могут быть обналичены или обменены на что-либо, имеющее реальную ценность.',
	},
	{
		id: 3,
		title: 'Чистое развлечение',
		text: 'Играйте ради удовольствия, соревнуясь с друзьями и совершенствуйте свои навыки!',
	},
];

const Faq = () => {
	return (
		<div className={styles.container}>
			<div className={styles.title}>Бесплатные развлечения, без ставок на реальные деньги</div>

			<div className={styles.list}>
				{FAQ_LIST.map(({ id, title, text }) => (
					<div key={id} className={styles.item}>
						<p className={styles.itemTitle}>{title}</p>
						<p className={styles.itemText}>{text}</p>
					</div>
				))}
			</div>
		</div>
	);
};

export default Faq;
